module.exports = __webpack_public_path__ + "img/skyline-logo-white.7e18850c.svg";